export const getCardType = (cardNumber: string) => {
  const amex = new RegExp('^3[47][0-9]{13}$');
  const visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');

  const mastercard = new RegExp('^5[1-5][0-9]{14}$');
  const mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

  const disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
  const disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
  const disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

  if (visa.test(cardNumber)) {
    return 'VISA';
  }

  if (amex.test(cardNumber)) {
    return 'AMEX';
  }

  if (mastercard.test(cardNumber) || mastercard2.test(cardNumber)) {
    return 'MASTERCARD';
  }

  if (disco1.test(cardNumber) || disco2.test(cardNumber) || disco3.test(cardNumber)) {
    return 'DISCOVER';
  }

  return;
};
